import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function VilleLaboratoire() {
  return (
    <PanelContent
      id="autoroute_pannel"
      route="/autoroute"
      title="Autoroute"
      subtitle="Une piste réglementaire pour l’évaluation des ADAS"
      description="Cette piste est la représentation d’une autoroute d’un kilomètre, composée de 5 voies extensibles à 9. Elle permet d’évaluer les fonctions d’aide à la conduite (ADAS) grâce à sa surface totalement plane et ses marquages répondant aux exigences réglementaires.  Son but est également d’accueillir les innovations de transport et de travaux qui interviennent sur autoroute."
      prev="/villelaboratoire"
      next="/routescampagne"
      txtbtn="ZONE SUIVANTE"
    />
  );
}
